import { Badge, Flex, Heading, RadioCards, Separator, Text } from '@radix-ui/themes'
import { badgeColors } from '@/shared/constants/constants'
import { CredentialGate } from '@/types/credential_gate'

interface Props {
  gate: CredentialGate
  value: string | null
  onChange: (category: string) => void
}

/**
 * Category picker for a credential-gated track. An option carries a status only
 * when we already know who is applying — on the guest form the email is typed on
 * this same screen, so statuses stay blank and the check happens on submit.
 */
export default function CredentialGatePicker({ gate, value, onChange }: Props) {
  return (
    <Flex direction="column" gap="3">
      <Flex direction="column" gap="1">
        <Heading size="6">What will you be doing?</Heading>
        <Text size="4" color="gray">
          {gate.track_name} asks media to complete an annual form for each of these. It expires December 31.
        </Text>
      </Flex>

      <RadioCards.Root
        columns={{ initial: '1', sm: '3' }}
        value={value ?? ''}
        onValueChange={onChange}
      >
        {gate.options.map((option) => (
          <RadioCards.Item key={option.category} value={option.category}>
            <Flex direction="column" width="100%" gap="1">
              <Text size="5" weight="bold" style={{ textTransform: 'capitalize' }}>
                {option.category}
              </Text>
              <Text size="2" color="gray">
                {option.title}
              </Text>
              {option.status && (
                <Badge
                  size="2"
                  variant="soft"
                  color={badgeColors[option.status]}
                  style={{ textTransform: 'capitalize', width: 'fit-content' }}
                >
                  {option.status}
                </Badge>
              )}
            </Flex>
          </RadioCards.Item>
        ))}
      </RadioCards.Root>

      <Separator size="4" />
    </Flex>
  )
}
